import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1163bbc4")

_pushScopeId("data-v-1163bbc4")
const _hoisted_1 = { class: "fridgedetails-selectdatebar" }
const _hoisted_2 = { class: "fridgedetails-selectdatebar-container" }
const _hoisted_3 = { class: "fridgedetails-selectdatebar-container-scrollarea-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsSelectDateBarItem = _resolveComponent("FridgeDetailsSelectDateBarItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "fridgedetails-selectdatebar-container-button",
        style: _ctx.leftButtonVisible,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.leftClick(...args)))
      }, [
        _createVNode("img", {
          class: "fridgedetails-selectdatebar-container-button-image",
          src: _ctx.leftButtonImage
        }, null, 8, ["src"])
      ], 4),
      _createVNode("div", {
        class: "fridgedetails-selectdatebar-container-scrollarea",
        ref: "scroll",
        style: _ctx.styleContentSize
      }, [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateList, (dateString) => {
            return (_openBlock(), _createBlock(_component_FridgeDetailsSelectDateBarItem, {
              style: _ctx.styleItems,
              key: dateString,
              dateString: dateString
            }, null, 8, ["style", "dateString"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ], 4),
      _createVNode("div", {
        class: "fridgedetails-selectdatebar-container-button",
        style: _ctx.rightButtonVisible,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rightClick(...args)))
      }, [
        _createVNode("img", {
          class: "fridgedetails-selectdatebar-container-button-image",
          src: _ctx.rightButtonImage
        }, null, 8, ["src"])
      ], 4)
    ])
  ]))
})